import { z } from 'zod'
import {
  BENEFICIARY_RELATION_I18N_KEYS,
  BENEFICIARY_RELATION_VALUES,
  beneficiaryRelationLabel,
  type BeneficiaryRelation,
} from '@/shared/schemas/beneficiaryDisplay.schema'

export { BENEFICIARY_RELATION_I18N_KEYS, BENEFICIARY_RELATION_VALUES, beneficiaryRelationLabel, type BeneficiaryRelation }

const relationEnum = z.enum(BENEFICIARY_RELATION_VALUES)

export const beneficiaryWriteSchema = z
  .object({
    nom: z
      .string()
      .trim()
      .min(1, { message: 'profile.beneficiary.nom_required' })
      .max(100, { message: 'profile.beneficiary.name_max' }),
    prenom: z
      .string()
      .trim()
      .min(1, { message: 'profile.beneficiary.prenom_required' })
      .max(100, { message: 'profile.beneficiary.name_max' }),
    date_naissance: z.string().max(10, { message: 'profile.beneficiary.birthdate_invalid' }).optional(),
    relation: relationEnum,
    relation_other: z.string().max(255).optional(),
  })
  .superRefine((values, ctx) => {
    if (values.relation === 'child' && (values.date_naissance ?? '').trim() === '') {
      ctx.addIssue({
        code: 'custom',
        path: ['date_naissance'],
        message: 'profile.beneficiary.child_birthdate_required',
      })
    }
    if (values.relation !== 'other') {
      return
    }
    const note = values.relation_other?.trim() ?? ''
    if (note === '') {
      ctx.addIssue({
        code: 'custom',
        path: ['relation_other'],
        message: 'profile.beneficiary.relation_other_required',
      })
    }
  })

export type BeneficiaryWriteInput = z.infer<typeof beneficiaryWriteSchema>

/** Empty create/reset form values; default relation is `child`. */
export const emptyBeneficiaryWrite = (): BeneficiaryWriteInput => ({
  nom: '',
  prenom: '',
  date_naissance: '',
  relation: 'child',
  relation_other: '',
})
